import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/page/LoginPage.vue'
import UsersPage from '@/page/UsersPage.vue'
import SportsStorePage from '@/page/SportsStorePage.vue'
import SportsStoreEditorPage from '@/page/SportsStoreEditorPage.vue'

const routes = [
  {
    path: '/',
    name: 'top',
    component: LoginPage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/user',
    name: 'user',
    component: UsersPage
  },
  {
    path: '/sportsstore',
    name: 'sportsstore',
    component: SportsStorePage
  },
  {
    path: '/sportsstoreedit',
    name: 'new-sportsstoreedit',
    component: SportsStoreEditorPage
  },
  {
    path: '/sportsstoreedit:sportsStoreId',
    name: 'update-sportsstoreedit',
    component: SportsStoreEditorPage,
    props: route => ({sportsStoreId: route.params.sportsStoreId}),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router